<template>
  <div class="login-dialog">
    <p class="login-lead">
      Sign in to reach your account, or create one.
    </p>

    <div class="login-fields">
      <label class="login-field">
        <span class="login-label">E-mail</span>
        <input
          v-model="email"
          class="emailpass"
          type="email"
          autocomplete="email"
          placeholder="you@company.com"
          @keyup.enter="login"
        >
      </label>
      <label class="login-field">
        <span class="login-label">Password</span>
        <input
          v-model="password"
          class="emailpass"
          type="password"
          autocomplete="current-password"
          placeholder="••••••••"
          @keyup.enter="login"
        >
      </label>
    </div>

    <div class="login-actions">
      <div
        id="send-button"
        :class="loginClass"
        @click="login"
      >
        {{ localize('TEXT_LOGIN') }}
      </div>
      <div
        id="send-button"
        :class="registerClass"
        @click="register"
      >
        {{ localize('TEXT_SIGN_UP') }}
      </div>
    </div>

    <span
      id="message"
      class="success"
    >
      {{ message }}
    </span>
  </div>
</template>
<script>

import {emit, inject, onMounted, ref, watch} from "vue";
import {translationStore} from "@/stores/translation";
import Axios from "axios";

export default {
    "name": "Login",
    "components": {
    },
    "props": {
    },
    "emits": [
        "hide-modal-event",
        "get-userinfo-event"
    ],
    setup (_, {emit}) {

        const emitHideModal = () => {

                emit(
                    "hide-modal-event",
                    false
                );

            },
            emitGetUserInfo = () => {

                emit(
                    "get-userinfo-event",
                    true
                );

            },
            email = ref(""),
            message = ref(""),
            emailOK = ref(false),
            emailAvailable = ref(false),
            password = ref(""),
            passwordOK = ref(false),
            registerClass = ref("send-inactive"),
            loginClass = ref("send-inactive"),
            loginText = ref(""),
            translation = translationStore(),
            text = ref(""),
            userInfo = inject("userInfo"),
            login = function () {

                if (loginClass.value == "send-inactive") {

                    validatePassword();
                    return;

                }
                Axios.post(
                    `${process.env.VUE_APP_SERVER_URI}login`,
                    {
                        "email": email.value,
                        "password": password.value
                    }
                ).
                    then((response) => {

                        if (response.data) {

                            if (response.data.authorized == true) {

                                document.getElementById("message").className = "success";
                                setTimeout(
                                    () => {

                                        close();

                                    },
                                    500
                                );

                            } else {

                                document.getElementById("message").className = "error";
                                message.value = translation.localize("LOGIN_FAILED");

                            }

                        }

                    }).
                    catch((error) => {

                        console.log(error);

                    });

            },
            register = function () {

                Axios.post(
                    `${process.env.VUE_APP_SERVER_URI}register`,
                    {
                        "email": email.value,
                        "password": password.value,
                        "language": userInfo.language,
                        "text": text.value
                    }
                ).
                    then((response) => {

                        if (response.data) {

                            if (response.data.status === "success") {

                                document.getElementById("message").className = "success";
                                message.value = translation.localize("CONTACT_WILL_CONTACT");
                                setTimeout(
                                    () => {

                                        close();

                                    },
                                    2000
                                );

                            } else {

                                document.getElementById("message").className = "error";
                                message.value = translation.localize("CONTACT_ERROR");

                            }

                        }

                    }).
                    catch((error) => {

                        console.log(error);

                    });

            },
            verifyEmail = function () {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}verifyUserEmail`,
                    {
                        "params": {
                            "email": email.value
                        }
                    }
                ).
                    then((response) => {

                        if (response.data) {

                            if (response.data.email === "available") {

                                document.getElementById("message").className = "success";
                                message.value = translation.localize("LOGIN_EMAIL_AVAILABLE");
                                emailAvailable.value = true;

                            } else {

                                document.getElementById("message").className = "error";
                                emailAvailable.value = false;
                                message.value = translation.localize("LOGIN_ALREADY_REGISTERED_EMAIL");

                            }
                            validateForm();

                        }

                    }).
                    catch((error) => {

                        console.log(error);

                    });

            },
            close = function () {

                emitGetUserInfo();
                emitHideModal();

            },
            validateEmail = function () {

                const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (email.value.match(re)) {

                    emailOK.value = true;
                    verifyEmail();

                } else {

                    emailOK.value = false;
                    message.value = translation.localize("LOGIN_INVALID_EMAIL");

                }

            },
            validatePassword = function () {

                if (password.value.length > 6) {

                    passwordOK.value = true;

                } else {

                    passwordOK.value = false;

                }
                validateForm();

            },
            validateForm = function () {

                if (emailAvailable.value == true && emailOK.value == true && passwordOK.value == true) {

                    registerClass.value = "send-active";
                    loginClass.value = "send-inactive";

                } else if (emailAvailable.value == false && emailOK.value == true && passwordOK.value == true) {

                    registerClass.value = "send-inactive";
                    loginClass.value = "send-active";

                } else {

                    registerClass.value = "send-inactive";
                    loginClass.value = "send-inactive";

                }

            };
        onMounted(() => {

            const count = ref(0);
            watch(
                email,
                () => {

                    validateEmail();

                }
            );
            watch(
                password,
                () => {

                    validatePassword();

                }
            );

        });
        return {"localize": translation.localize,
            close,
            text,
            email,
            password,
            message,
            email,
            emailOK,
            emailAvailable,
            password,
            passwordOK,
            registerClass,
            login,
            loginClass,
            loginText,
            register,
            text,
            userInfo,
            validateEmail,
            validateForm,
            validatePassword,
            verifyEmail,
            emitHideModal,
            emitGetUserInfo};

    }
};

</script>
<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.login-dialog {
  pointer-events: all;
}
.login-lead {
  margin: 0 0 22px;
  font-family: var(--font-body);
  font-size: 0.92em;
  line-height: 1.5;
  color: var(--text-secondary);
}
.login-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.login-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.login-label {
  font-family: var(--font-heading);
  font-size: 0.72em;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
}
input.emailpass::placeholder {
  color: var(--text-muted);
}
/* Matched to the demo form: a soft violet field that answers a focus with a
   ring rather than a colour change, which is easier to see and does not move
   anything. */
input.emailpass {
  width: 100%;
  padding: 14px 16px;
  font-family: var(--font-body);
  font-size: 1em;
  border: 2px solid rgba(124, 58, 237, 0.12);
  border-radius: 12px;
  background: rgba(124, 58, 237, 0.04);
  color: var(--text-primary);
  outline: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}
input.emailpass:hover {
  border-color: rgba(124, 58, 237, 0.24);
}
input.emailpass:focus {
  border-color: #7c3aed;
  background: rgba(124, 58, 237, 0.06);
  box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.12);
}
.login-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 26px;
}
/* One button carries the gradient and the other does not, so which one is the
   way forward is visible before reading either. Both keep their size when
   they change state, so nothing shifts under the pointer. */
.send-inactive,
.send-active {
  flex: 1;
  padding: 14px 24px;
  border-radius: 30px;
  font-family: var(--font-heading);
  font-size: 0.9em;
  font-weight: 700;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease,
    color 0.3s ease, border-color 0.3s ease;
}
.send-inactive {
  border: 2px solid var(--border-subtle);
  background: transparent;
  color: var(--text-muted);
  cursor: default;
}
.send-active {
  cursor: pointer;
  border: 2px solid transparent;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed 0%, #6366f1 45%, #06b6d4 100%);
  box-shadow: 0 8px 28px rgba(99, 102, 241, 0.32);
}
.send-active:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 40px rgba(6, 182, 212, 0.4);
}
.send-active:active {
  transform: translateY(0);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.3);
}
#message {
  display: block;
  margin-top: 18px;
  font-family: var(--font-body);
  font-size: 0.88em;
  min-height: 1.2em;
  transition: color 0.25s ease;
}
.error {
  color: #e2565f;
}
.success {
  color: #10b981;
}
#message {
  font-size: 0.8em;
  margin: 15px;
  transition: all 500ms ease-in-out;
}
</style>
